import type { ZodIssue } from 'zod'

export class ValidationError extends Error {
  issues: Record<string, string>

  constructor(issues: ZodIssue[]) {
    super('Validation error')
    this.issues = Object.fromEntries(issues.map(issue => [issue.path.join('.'), issue.message]))
  }
}
